import React from 'react';
import { baseCss } from '../css';

const Radio = ({ active, onClick }) => (
    <div
        className='radio-btn'
        style={baseCss.primaryBorder}
        onClick={onClick}
    >
        <div style={active ? baseCss.primaryBackground : {}}  className={`${active?'rdoActive':''}`}></div>
    </div>
)

export const RadioCheckout = ({ active, onClick }) => (
    <div
        className='radio-btn'
        style={active ? { border: '2px solid #fff' } : { border: '2px solid #757575' }}
        onClick={onClick}
    >
        <div style={active ? { background: "#01AEF0" } : {}}></div>
    </div>
)

export const GenderRadio = ({ active, male, disable, onClick, className, label }) => (
    <div
        className={`gender-radio ${className} ${active ? ' active' : ''}${disable ? ' disable' : ''}`}
        onClick={onClick}
    >
        <div className='radio-btn'>
            <div></div>
        </div>
        {label}
    </div>
)

export default Radio